import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@rainbow-me/rainbowkit/styles.css';

import { 
  RainbowKitProvider, 
  connectorsForWallets, 
  lightTheme 
} from '@rainbow-me/rainbowkit';

// IMPORT DOMPET YANG SUDAH DIKOREKSI
import {
  trustWallet,
  bitgetWallet,
  okxWallet,
  metaMaskWallet,
  coinbaseWallet,
  walletConnectWallet,
  injectedWallet,
  rabbyWallet,
  phantomWallet,
  safepalWallet // Diperbaiki: menggunakan 'p' kecil
} from '@rainbow-me/rainbowkit/wallets';

import { configureChains, createConfig, WagmiConfig } from 'wagmi';
import { bsc } from 'wagmi/chains';
import { publicProvider } from 'wagmi/providers/public';
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc';
import { AirdropPage } from './components/AirdropPage';
import { SwapPage } from './components/SwapPage';
import { Header } from './components/Header';
import { CHAIN_ID, RPC_URL } from './config';
import GlobalStyle from './styles/globalStyles';

const { chains, publicClient } = configureChains(
  [bsc],
  [
    jsonRpcProvider({ rpc: () => ({ http: RPC_URL }) }),
    publicProvider(), 
  ],
);

const projectId = '374c230611a3deb81bab39e386e46705'; 

// --- DAFTAR DOMPET LENGKAP ---
const connectors = connectorsForWallets([
  {
    groupName: 'Recommended',
    wallets: [
      trustWallet({ projectId, chains }),                 // 1. Trust Wallet
      bitgetWallet({ projectId, chains }),                // 2. Bitget Wallet
      okxWallet({ projectId, chains }),                   // 3. OKX Wallet
      metaMaskWallet({ projectId, chains }),              // 4. MetaMask
      coinbaseWallet({ appName: 'FORU Portal', chains }), // 5. Coinbase
      walletConnectWallet({ projectId, chains }),         // 6. Wallet Connect
      injectedWallet({ chains }),                         // 7. Browser Wallet (Termasuk Binance)
      rabbyWallet({ chains }),                            // 8. Rabby Wallet
      phantomWallet({ chains }),                          // 9. Phantom
      safepalWallet({ projectId, chains }),               // 10. SafePal
    ],
  },
]);

const wagmiConfig = createConfig({
  autoConnect: true,
  connectors,
  publicClient,
});

function App() {
  return (
    <WagmiConfig config={wagmiConfig}>
      <RainbowKitProvider 
        chains={chains} 
        theme={lightTheme({
          accentColor: '#0E76FD', 
          accentColorForeground: 'white',
          borderRadius: 'large',
          fontStack: 'system',
        })}
      >
        <GlobalStyle /> 
        <BrowserRouter>
          <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflowY: 'auto' }}>
            <Header />
            <Routes>
              <Route path="/" element={<AirdropPage />} />
              <Route path="/swap" element={<SwapPage />} />
            </Routes>
          </div>
        </BrowserRouter>
      </RainbowKitProvider>
    </WagmiConfig>
  );
}

export default App;